import React from 'react'

import { getAdBusinessName, getAdCallToActionText } from '../../helpers'

function NameSectionPreview({ ad }) {
  const businessName = getAdBusinessName(ad)
  const callToActionText = getAdCallToActionText(ad)

  return (
    <>
      {businessName && (
        <p>
          <span>
            <strong>Business Name</strong>
          </span>
          <span>{businessName}</span>
        </p>
      )}
      {callToActionText && (
        <p>
          <span>
            <strong>Call To Action</strong>
          </span>
          <span>{callToActionText}</span>
        </p>
      )}
    </>
  )
}

export default NameSectionPreview
